import MillManagementListContainer from './MillManagementListContainer'

function MillManagementListScreen(): JSX.Element {
    return <MillManagementListContainer />
}

export default MillManagementListScreen
